import classes from './SlotForm.module.sass'
import { format } from 'date-fns'
import { useSlotForm } from './hooks/useSlotForm'
import { Input } from '../../../common/components/input/Input'
import { Textarea } from '../../../common/components/textarea/Textarea'
import { Button } from '../../../common/components/button/Button'
import { FormStage } from '../../../common/types/enums'
import { FileUpload } from '../../../common/components/fileUpload/FileUpload'
import { PointForm } from '../../../common/components/form/pointForm/PointForm'
import { GMapForMarker } from '../../../common/components/maps/gMapForMarker/GMapForMarker'
import { russiaCenter } from '../../../common/utils/constants'
import { Helmet } from 'react-helmet-async'
import { CargoSelector } from '../../../common/components/cargoSelector/CargoSelector'
import TransportTypeSelector from '../../../common/components/transportTypeSelector/TransportTypeSelector'
import { Toggle } from '../../../common/components/toggle/Toggle'

export const SlotForm = () => {
  const {
    inputHandler,
    data,
    setData,
    getValidationResult,
    disabled,
    setDirty,
    formStage,
    setFormStage,
    disabled1,
    disabled2,
    formAction,
    files,
    setFiles,
    pairs,
    setPairs,
    intercity,
    addresses,
    isRoute,
    edit,
    editPointsData,
    setCargoTypeValid,
    setTransportTypeValid,
    toggleStartImportant,
    toggleEndImportant,
  } = useSlotForm()

  return (
    <div className={classes.Container} onClick={(e) => e.stopPropagation()}>
      <Helmet>
        <title>{`logid - форма добавления слота для курьеров`}</title>
        <meta
          name="description"
          content={`Добавить слот с указанием адреса и ставки для курьера`}
        />
      </Helmet>
      <div className={classes.Title}>{edit ? 'Редактирование слота' : 'Новый слот'}</div>
      {formStage === FormStage.ONE && (
        <div className={classes.StageContainer}>
          <CargoSelector
            setTopData={setData}
            setCargoTypeValid={setCargoTypeValid}
            topData={data}
          />
          <TransportTypeSelector
            setTopData={setData}
            setTransportTypeValid={setTransportTypeValid}
            topData={data}
          />
          <Input
            type={'text'}
            fieldName={'name'}
            value={data.name}
            placeHolder={'Название слота'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('name')}
            onBlur={setDirty}
          />

          <Textarea
            type={'textarea'}
            fieldName={'description'}
            value={data.description}
            placeHolder="Опишите слот подробно"
            rows={5}
            cols={20}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('description')}
            onBlur={setDirty}
          />

          <Input
            type={'numberText'}
            fieldName={'cost'}
            value={data.cost ? data.cost : ''}
            placeHolder={'Предлагаемая ставка'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('cost')}
            onBlur={setDirty}
          />
        </div>
      )}

      {formStage === FormStage.TWO && (
        <div className={classes.StageContainer}>
          <PointForm
            addresses={addresses}
            intercity={intercity}
            topData={data}
            setTopData={setData}
            isRoute={isRoute}
            initialData={editPointsData && editPointsData}
          />
          <div className={classes.MapContainer}>
            <GMapForMarker center={russiaCenter} item={data} />
          </div>
        </div>
      )}

      {formStage === FormStage.THREE && (
        <div className={classes.StageContainer}>
          {/* <Regularity /> */}

          <div className={classes.TimeContainer}>
            <div className={classes.ToggleContainer}>
              <Toggle
                id={'start_important'}
                onChange={toggleStartImportant}
                checked={data.start_important}
              />
              <div>Указать время начала</div>
            </div>

            {data.start_important && (
              <>
                <Input
                  label="Время подачи"
                  type="datetime-local"
                  fieldName="startTime"
                  onChangeHandler={inputHandler}
                  value={`${format(new Date(data.startTime), 'yyyy-MM-dd')}T${format(
                    new Date(data.startTime),
                    'HH:mm',
                  )}`}
                />
                <div className={classes.ToggleContainer}>
                  <Toggle
                    id={'end_time'}
                    onChange={toggleEndImportant}
                    checked={data.end_important}
                  />
                  <div>Указать время окончания</div>
                </div>
              </>
            )}
            {data.end_important && (
              <Input
                label="Время завершения"
                type="datetime-local"
                fieldName="endTime"
                onChangeHandler={inputHandler}
                value={`${format(new Date(data.endTime), 'yyyy-MM-dd')}T${format(
                  new Date(data.endTime),
                  'HH:mm',
                )}`}
              />
            )}
          </div>

          <FileUpload
            length={3}
            min_length={1}
            extensions={['jpeg', 'png', 'jpg', 'webp']}
            files={files}
            setFiles={setFiles}
            pairs={pairs}
            setPairs={setPairs}
          />
        </div>
      )}

      <div className={classes.ButtonsContainer}>
        {formStage !== FormStage.ONE && (
          <Button
            text={'Назад'}
            onClick={() => {
              setFormStage((prev) => prev - 1)
              window.scroll(0, 0)
            }}
          />
        )}

        <Button
          text={formStage !== FormStage.THREE ? 'Продолжить' : edit ? 'Сохранить' : 'Добавить cлот'}
          disabled={
            (disabled && formStage === FormStage.THREE) ||
            (disabled1 && formStage === FormStage.ONE) ||
            (disabled2 && formStage === FormStage.TWO)
          }
          onClick={() => {
            if (formStage !== FormStage.THREE) {
              setFormStage((prev) => prev + 1)
              window.scroll(0, 0)
            } else formAction()
          }}
        />
      </div>
    </div>
  )
}
